const OfferSpendPageLangKey = [
	'btn_add_new'
] as const

type IOfferSpendPageLangKey = typeof OfferSpendPageLangKey[number]

export type IOfferSpendPageLang = {
	offer_spend_page: Record<IOfferSpendPageLangKey, string>
}

const langEntries = OfferSpendPageLangKey.map(
	(key: IOfferSpendPageLangKey) => [key, `offer_spend_page.${key}`]
)

const langObj: Record<IOfferSpendPageLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SPEND_PAGE_LANG_KEY: IOfferSpendPageLang = {
	offer_spend_page: langObj
}
